import Layout from '@/layouts/RouterView'
import i18n from '@/locales'
import store from '@/store'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'
import { hasServices, featureMenuHiddenCheck } from '@/utils/auth'
import monitorRouter from '@generalScope/ceRouter/monitor'

// 报表
const ReportSetting = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/report-setting')
const ReportElement = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/report-element')
// const ReportData = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/report-data')
// const ReportSubscriptionCreate = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/report-data/subscription/create')
// const ReportCustom = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/report-custom')
const MonthReport = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/month-report')
const DailyReport = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/daily-report')
const MonthReportCreate = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/month-report/create')
const DailyReportCreate = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/daily-report/create')
const DailyReportEdit = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/daily-report/edit')
const ReportTemplate = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/report-template')
const ReportTemplateCreate = () => import(/* webpackChunkName: "report" */ /* webpackPrefetch: true */ '@Reports/views/report-template/create')

const DeadlyResource = () => import(/* webpackChunkName: "compute" */ /* webpackPrefetch: true */ '@Compute/views/deadly-resource')

export default {
  index: 65,
  meta: {
    label: i18n.t('dictionary.menu_monitor_operation'),
    t: 'dictionary.menu_monitor_operation',
    icon: 'monitor-operation',
  },
  menus: [
    ...monitorRouter.menus,
    {
      meta: {
        label: i18n.t('report.report_config'),
        hidden: () => !hasServices('report'),
      },
      subGroup: 'report',
      submenus: [
        {
          path: '/report-element',
          meta: {
            label: i18n.t('report.report_elements'),
            permission: 'report_elements_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.report_element')) {
                return true
              }
              if (store.getters.isProjectMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'ReportElement',
              path: '',
              component: ReportElement,
            },
          ],
        },
        {
          path: '/report-setting',
          meta: {
            label: i18n.t('report.report_setting'),
            permission: 'report_settings_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.report_setting')) {
                return true
              }
              if (store.getters.isProjectMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'ReportSetting',
              path: '',
              component: ReportSetting,
            },
          ],
        },
        {
          path: '/report-template',
          meta: {
            label: i18n.t('report.report_template_library'),
            permission: 'report_templates_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.report_template')) {
                return true
              }
              if (store.getters.isProjectMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'ReportTemplate',
              path: '',
              component: ReportTemplate,
            },
            {
              name: 'ReportTemplateCreate',
              path: 'create',
              component: ReportTemplateCreate,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('report.report_subscription'),
      },
      subGroup: 'report',
      submenus: [
        {
          path: '/month-report-subscription',
          meta: {
            label: i18n.t('report.month_report'),
            permission: 'month_reports_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.report_subscription')) {
                return true
              }
              if (store.getters.isProjectMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'MonthReport',
              path: '',
              component: MonthReport,
            },
            {
              name: 'MonthReportCreate',
              path: 'create',
              component: MonthReportCreate,
            },
            {
              name: 'MonthReportEdit',
              path: 'edit',
              component: DailyReportEdit,
            },
          ],
        },
        {
          path: '/daily-report-subscription',
          meta: {
            label: i18n.t('report.daily_report'),
            permission: 'daily_reports_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.daily_report_subscription')) {
                return true
              }
              if (store.getters.isProjectMode) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'DailyReport',
              path: '',
              component: DailyReport,
            },
            {
              name: 'DailyReportCreate',
              path: 'create',
              component: DailyReportCreate,
            },
            {
              name: 'DailyReportEdit',
              path: 'edit',
              component: DailyReportEdit,
            },
          ],
        },
      ],
    },
    // 临期资源
    {
      meta: {
        label: i18n.t('scope.products_group.operation_report'),
      },
      subGroup: 'report',
      submenus: [
        {
          path: '/deadly-resource',
          meta: {
            label: i18n.t('compute.deadly_resource'),
            permission: 'billing_resource_checks_list',
            hidden: (userInfo, menu) => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.deadly_resource')) {
                return true
              }
              return featureMenuHiddenCheck(menu)
            },
          },
          component: Layout,
          children: [
            {
              name: 'DeadlyResource',
              path: '',
              component: DeadlyResource,
            },
          ],
        },
      ],
    },
  ],
}
